module.exports = __webpack_public_path__ + "static/media/m6sj.25230818.png";